import { useFormContext } from "react-hook-form";
import { Button, ErrorMessage, Loading, TextInput, Typography } from "@/components/atoms";
import { GoogleTagManagerConfiguration } from "@/redux/slices/addOn/types";

interface GoogleTagManagerEditProps {
  onSubmit: () => void;
  onClose: () => void;
  isLoading?: boolean;
}

export const GoogleTagManagerEdit = ({ onSubmit, onClose, isLoading }: GoogleTagManagerEditProps) => {
  const {
    formState: { isDirty, errors },
    register,
  } = useFormContext<GoogleTagManagerConfiguration>();

  const renderButtons = () => (
    <div className="mt-8 flex w-full flex-row items-center justify-end gap-x-4">
      <Button variant="secondary" size="sm" onClick={onClose}>
        Cancel
      </Button>
      <Button variant="primary" size="sm" type="submit" disabled={!isDirty || isLoading}>
        Save Settings
      </Button>
    </div>
  );

  return (
    <form onSubmit={onSubmit}>
      <div className="pointer-events-auto relative my-4 flex w-full flex-col rounded-lg border border-primary bg-neutral-surface-gray p-5">
        {isLoading && <Loading className="rounded-lg" />}
        <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
          <div className="flex flex-1 flex-col">
            <Typography variant="action">GTM Property ID</Typography>
            <Typography variant="paragraph" className="text-neutral-dark-gray">
              Set your property ID
            </Typography>
          </div>
          <TextInput
            className="w-full sm:w-60"
            placeholder="GTM-XXXXXXXX"
            maxLength={12}
            hasError={!!errors.property}
            {...register("property")}
          />
        </div>
        <ErrorMessage errors={errors} name="property" className="self-start sm:self-end" />
        {renderButtons()}
      </div>
    </form>
  );
};
